import { Component, ElementRef, inject, input, output, ViewEncapsulation } from '@angular/core';
import { TooltipDirective } from '../../../tooltip/tooltip.directive';

@Component({
    selector: 'app-content-dropdown-item-cabinet',
    templateUrl: './content-dropdown-item.component.html',
    styleUrls: ['./content-dropdown-item.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [TooltipDirective],
    host: {
        '[attr.role]': "selected() === null ? 'menuitem' : 'menuitemcheckbox'",
        '[attr.aria-checked]': 'selected() === null ? null : selected()',
        tabindex: '-1',
        '[attr.aria-disabled]': "disabled() || locked() ? 'true' : null",
        '[class.checkable]': 'selected() !== null',
        '[class.locked]': 'locked()',
        '[class.disabled]': 'disabled()',
        '[class.tone-danger]': "tone() === 'danger'",
        '(click)': 'onHostClick($event)',
        '(keydown)': 'onHostKeydown($event)'
    }
})
export class ContentDropdownItemCabinetComponent {
    private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

    /**
     * A filter or option the item turns on and off: true/false shows a check
     * and exposes the state (menuitemcheckbox). Left null, a plain action.
     */
    selected = input<boolean | null>(null);
    disabled = input<boolean>(false);
    locked = input<boolean>(false);
    lockedMessage = input<string>('Not available in your subscription');
    /** `danger` marks a destructive item; place it last, after a separator. */
    tone = input<'default' | 'danger'>('default');
    itemClick = output<void>();

    onHostClick(event: Event): void {
        if (this.disabled() || this.locked()) {
            event.stopImmediatePropagation();
            event.preventDefault();
        }
    }

    /** Enter and Space activate the item like a click. */
    onHostKeydown(event: KeyboardEvent): void {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.host.nativeElement.click();
    }

    onClick(): void {
        if (!this.disabled() && !this.locked()) {
            this.itemClick.emit();
        }
    }
}
